import { motion } from 'framer-motion';
import { Ship } from 'lucide-react';
import { VESSEL_CATEGORIES } from '../types';
import clsx from 'clsx';

interface VesselCategoriesProps {
  onCategoryClick?: (category: string) => void;
  selectedCategory?: string;
}

const categoryColors = [
  'border-l-blue-500',
  'border-l-green-500',
  'border-l-amber-500',
  'border-l-purple-500',
];

export function VesselCategories({ onCategoryClick, selectedCategory }: VesselCategoriesProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: 0.3 }}
    >
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Vessel Categories</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {VESSEL_CATEGORIES.map((category, index) => (
          <motion.button
            key={category.value}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: 0.3 + index * 0.05 }}
            whileHover={{ y: -2 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => onCategoryClick?.(category.value)}
            className={clsx(
              'card card-hover text-left border-l-4',
              categoryColors[index],
              selectedCategory === category.value && 'ring-2 ring-primary-500 ring-offset-2'
            )}
          >
            <div className="flex items-center gap-3 mb-2">
              <Ship className="w-5 h-5 text-gray-400" />
              <span className="font-medium text-gray-900">{category.label}</span>
            </div>
            <span className="text-sm text-gray-500">{category.teu}</span>
          </motion.button>
        ))}
      </div>
    </motion.div>
  );
}
